module.exports = __webpack_public_path__ + "assets/img/mecha-btn-2cbbeca0.png";